export enum MessageGatewayEventsEnum {
    PATH = '/socket/message',
    CONFIRM_PAYMENT_REQUEST = 'CONFIRM_PAYMENT_REQUEST',
    CONFIRM_PAYMENT_RESPONSE = 'CONFIRM_PAYMENT_RESPONSE',
}